'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _reactImmutableProptypes = require('react-immutable-proptypes');

var _reactImmutableProptypes2 = _interopRequireDefault(_reactImmutableProptypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var siteShape = _reactImmutableProptypes2.default.contains({
  siteId: _react.PropTypes.string,
  libraryId: _react.PropTypes.number,
  shortName: _react.PropTypes.string,
  longName: _react.PropTypes.string,
  logo: _react.PropTypes.string,
  domain: _react.PropTypes.string
});

exports.default = siteShape;


//////////////////
// WEBPACK FOOTER
// ../biblio-ui-glue/src/bc-prop-types/lib/components/siteShape.js
// module id = 44
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14